import { OrgRegistrationForm } from '@/features/Auth';

const OrgRegistrationPage = () => {
  return <OrgRegistrationForm />;
};

export default OrgRegistrationPage;